import React from 'react';
import { LayoutDashboard, Users, UploadCloud, History, LogOut, Settings } from 'lucide-react';
import { motion } from 'framer-motion';
interface SidebarProps {
  activePage: string;
  onNavigate: (page: string) => void;
}
export function Sidebar({
  activePage,
  onNavigate
}: SidebarProps) {
  const navItems = [{
    id: 'dashboard',
    label: 'Dashboard',
    icon: LayoutDashboard
  }, {
    id: 'teams',
    label: 'Teams',
    icon: Users
  }, {
    id: 'upload',
    label: 'Upload Leads',
    icon: UploadCloud
  }, {
    id: 'history',
    label: 'History',
    icon: History
  }];
  return <div className="h-screen w-64 bg-[#1a1a2e] text-gray-300 flex flex-col flex-shrink-0 border-r border-gray-800" data-id="element-21">
      {/* Header */}
      <div className="p-6 flex items-center space-x-3 border-b border-gray-800" data-id="element-22">
        <div className="h-8 w-8 bg-indigo-500 rounded-lg flex items-center justify-center text-white font-bold" data-id="element-23">
          MR
        </div>
        <span className="text-white font-semibold text-lg tracking-tight" data-id="element-24">
          Mortgage Router
        </span>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 py-6 space-y-1" data-id="element-25">
        {navItems.map(item => {
        const isActive = activePage === item.id;
        const Icon = item.icon;
        return <button key={item.id} onClick={() => onNavigate(item.id)} className={`
                w-full flex items-center px-3 py-2.5 rounded-md text-sm font-medium transition-colors
                ${isActive ? 'bg-indigo-600 text-white shadow-md' : 'text-gray-400 hover:bg-gray-800 hover:text-white'}
              `} data-id="element-26">
              <Icon className={`mr-3 h-5 w-5 ${isActive ? 'text-white' : 'text-gray-500 group-hover:text-white'}`} data-id="element-27" />
              {item.label}
              {isActive && <motion.div layoutId="activeIndicator" className="absolute left-0 w-1 h-8 bg-indigo-400 rounded-r-full" initial={false} transition={{
            type: 'spring',
            stiffness: 300,
            damping: 30
          }} data-id="element-28" />}
            </button>;
      })}
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-gray-800" data-id="element-29">
        <div className="flex items-center px-3 py-2 text-sm font-medium text-gray-400 hover:text-white cursor-pointer rounded-md hover:bg-gray-800 transition-colors" data-id="element-30">
          <Settings className="mr-3 h-5 w-5 text-gray-500" data-id="element-31" />
          Settings
        </div>
        <div className="flex items-center px-3 py-2 text-sm font-medium text-gray-400 hover:text-white cursor-pointer rounded-md hover:bg-gray-800 transition-colors mt-1" data-id="element-32">
          <LogOut className="mr-3 h-5 w-5 text-gray-500" data-id="element-33" />
          Sign Out
        </div>

        <div className="mt-6 px-3 flex items-center" data-id="element-34">
          <div className="h-8 w-8 rounded-full bg-gray-700 flex items-center justify-center text-xs text-white font-medium" data-id="element-35">
            JD
          </div>
          <div className="ml-3" data-id="element-36">
            <p className="text-sm font-medium text-white" data-id="element-37">John Doe</p>
            <p className="text-xs text-gray-500" data-id="element-38">Branch Manager</p>
          </div>
        </div>
      </div>
    </div>;
}